/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_circle': {
    width: 16,
    height: 16,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M256 0C115.39 0 0 115.39 0 256s115.39 256 256 256 256-115.39 256-256S396.61 0 256 0z"/>'
  }
})
